import React from 'react';

import NodeDetails from '../../components/node-details/node-details';

const NodeOverview: React.FC = () => (
  <NodeDetails />
);

export default NodeOverview;
